export function initFooterReveal() {
  const footer = document.querySelector(".c-site-footer");
  if (!(footer instanceof HTMLElement)) return;
  footer.style.setProperty("--footer-bg-dark-opacity", "0");
}
